import { Group, Image, type MantineSize, rem } from '@mantine/core';
import Link from 'next/link';
export type LogoProps = {
  visibleForm?: MantineSize;
  hiddenFrom?: MantineSize;
};
export const Logo: React.FC<LogoProps> = ({
  visibleForm,
  hiddenFrom
}) => {
  return <Group justify="center" visibleFrom={visibleForm} hiddenFrom={hiddenFrom} h={rem(90)}>
      <Link href="/">
        <Image src="/apisus.png" alt="Prime logo" w={{
        base: 100,
        md: 117
      }} />
      </Link>
    </Group>;
};